export default __webpack_public_path__ + "static/media/2380.6c3801db.png";